const es = {
  code: "es",
  nav: { book: "Reservar", whatsapp: "WhatsApp", menu: "Menú" },
  hero: {
    eyebrow: "Tenerife · Costa sur · Salidas diarias",
    lines: ["Las mejores excursiones de Tenerife,", "reservadas en un minuto."],
    sub: "Disponibilidad en tiempo real, pago al instante y tu bono con código QR en el correo antes de soltar el móvil.",
    ctaBook: "Reservar online",
    ctaWa: "Escribir por WhatsApp",
    trust: ["Cancelación gratuita", "Confirmación inmediata", "Bono con código QR", "Pago seguro con tarjeta"],
    scroll: "Desliza",
  },
  marquee: ["Disponibilidad en tiempo real", "Paga en menos de un minuto", "Bono QR por correo", "Cancelación gratuita hasta 24 h", "Equipo local, grupos reducidos", "4,9 según 2.300 clientes"],
  trips: {
    eyebrow: "Excursiones de hoy",
    title: "Tres excursiones. Fechas reales. Sin esperas.",
    sub: "Cada fecha que ves está realmente libre. Elige una, paga y tu bono ya está en camino.",
    perPerson: "por persona",
    duration: "Duración",
    departs: "Salida",
    included: "Qué incluye",
    pickDate: "Elige una fecha",
    people: "Personas",
    total: "Total",
    pay: "Pagar",
    payNow: "Pagar y recibir el bono",
    free: "Libre",
    few: "Últimas plazas",
    full: "Completo",
    spotsLeft: "plazas libres",
    selectDateFirst: "Elige una fecha libre para continuar",
    hours: "horas",
    meeting: "Punto de encuentro",
    live: "Disponibilidad en vivo",
    items: {
      jetski: {
        title: "Safari en Moto de Agua",
        tagline: "Dos horas recorriendo la costa sur en tu propia moto de agua, con guía todo el trayecto.",
        includes: ["Moto de agua propia (1–2 personas)", "Guía titulado y briefing", "Neopreno, chaleco y taquillas", "Fotos de tu ruta"],
        meeting: "Puerto Colón, Pantalán 3",
      },
      catamaran: {
        title: "Catamarán Ballenas y Delfines",
        tagline: "Tres horas navegando con calderones residentes, parada para nadar y almuerzo a bordo.",
        includes: ["Avistamiento garantizado", "Almuerzo, bebidas y fruta", "Parada para nadar y snorkel", "Recogida en hoteles del sur"],
        meeting: "Puerto de Los Cristianos, Puerta B",
      },
      teide: {
        title: "Teide: Atardecer y Estrellas",
        tagline: "Cinco horas sobre las nubes: atardecer en el borde del cráter y el cielo con un guía Starlight.",
        includes: ["Minibús con aire acondicionado", "Guía astrónomo y telescopios", "Chocolate caliente y manta", "Recogida y regreso al hotel"],
        meeting: "Recogida en tu hotel",
      },
    },
  },
  payment: {
    title: "Pago seguro",
    sub: "Paga con tarjeta. Tu bono con código QR llega a tu correo en cuanto se confirma el pago.",
    name: "Nombre completo",
    email: "Correo para el bono",
    card: "Número de tarjeta",
    expiry: "Caducidad",
    cvc: "CVC",
    pay: "Pagar",
    processing: "Confirmando tu fecha…",
    secure: "Cifrado de 256 bits · Protegido por 3-D Secure",
    demo: "Pago de demostración: no se cobrará ninguna tarjeta.",
    summary: "Resumen del pedido",
    error: "Algo ha salido mal. Inténtalo de nuevo.",
    dateGone: "Esa fecha se acaba de agotar. Elige otra.",
    freeCancel: "Cancelación gratuita hasta 24 horas antes de la salida",
  },
  voucher: {
    eyebrow: "Pago confirmado",
    title: "Reserva hecha.",
    sent: "Tu bono se ha enviado a",
    code: "Código de reserva",
    show: "Muestra este código QR en el punto de encuentro",
    date: "Fecha",
    time: "Hora",
    people: "Personas",
    paid: "Pagado",
    meeting: "Punto de encuentro",
    download: "Descargar bono",
    done: "Listo",
    bookAnother: "Reservar otra excursión",
  },
  how: {
    eyebrow: "Cómo funciona",
    title: "Tres pasos, un minuto.",
    steps: [
      { t: "Elige una fecha libre", d: "El calendario muestra lo que realmente está disponible hoy. Si está en verde, es tuyo." },
      { t: "Paga con tarjeta", d: "Apple Pay, Google Pay o cualquier tarjeta. Tus plazas quedan bloqueadas en el momento del pago." },
      { t: "Llega tu bono", d: "Un bono con código QR llega por correo al instante. Muéstralo en el móvil y listo." },
    ],
  },
  reviews: {
    eyebrow: "Opiniones",
    title: "Lo que cuentan al volver.",
    items: [
      { name: "Hannah Whitmore", place: "Manchester, Reino Unido", trip: "Safari en Moto de Agua", text: "Reservé en el desayuno y a las diez y media estaba en el agua. El bono llegó antes de terminar el café. El guía fue genial y las fotos son increíbles." },
      { name: "Lukas Brandt", place: "Hamburgo, Alemania", trip: "Catamarán Ballenas y Delfines", text: "Vimos calderones en veinte minutos. Almuerzo a bordo, baño en una cala tranquila, sin aglomeraciones. El check-in con QR tardó unos tres segundos." },
      { name: "Chiara Moretti", place: "Milán, Italia", trip: "Teide: Atardecer y Estrellas", text: "Solo el atardecer sobre las nubes ya valía la pena, y luego las estrellas. Nuestro guía lo sabía todo. La recogida fue puntual al minuto." },
    ],
    verified: "Reserva verificada",
  },
  faq: {
    eyebrow: "Preguntas frecuentes",
    title: "Lo que conviene saber.",
    items: [
      { q: "¿Qué incluye el precio?", a: "Todo lo que aparece en la tarjeta de la excursión: equipo, guía, seguro y la comida o recogida indicadas. Sin gastos de gestión ni sorpresas en el punto de encuentro." },
      { q: "¿Puedo cancelar o cambiar la fecha?", a: "Sí. Cancela gratis hasta 24 horas antes de la salida con reembolso completo, o cambia tu reserva a cualquier otra fecha libre con un solo mensaje por WhatsApp." },
      { q: "¿Qué pasa si cambia el tiempo?", a: "La seguridad es lo primero. Si el capitán o el guía cancela por meteorología, tú eliges: nueva fecha, otra excursión o reembolso completo el mismo día. Nunca perderás tu dinero." },
      { q: "¿Cómo uso el bono QR?", a: "Solo tienes que mostrarlo en el móvil en el punto de encuentro. Sin imprimir ni papeleo. El equipo lo escanea y a bordo." },
    ],
  },
  footer: {
    tagline: "Excursiones en grupos reducidos por la costa sur de Tenerife, organizadas por quienes vivimos aquí.",
    contact: "Contacto",
    whatsapp: "Chatear por WhatsApp",
    call: "Llámanos",
    email: "Correo",
    payments: "Aceptamos",
    hours: "Abierto todos los días de 08:00 a 21:00",
    built: "Diseñado y desarrollado por",
    rights: "Todos los derechos reservados.",
    legal: "Operador turístico con licencia · Registrado en Santa Cruz de Tenerife",
  },
  mobile: { from: "Desde", book: "Reservar" },
};
export default es;
